document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  const $priceDom = $('#sp_price1');
  const $cPriceDom = $('#sp_price2');
  const $offPriceDom = $('.font-off');
  const $numDom = $('#calcNumber');

  const productData = window.product || [];

  // 跳转支付页面
      $(document).on('click', '.sp-btn-style', function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })

  /** 获取当前选中的变量 */
  function getCur() {
    const opts = {
      option1: $('#sp-opt-group1 div.active').attr('data-val'),
      option2: $('#sp-opt-group2 div.active').attr('data-val'),
      option3: $('#sp-opt-group3 div.active').attr('data-val')
    };

    return productData.find(item => {
      return (!opts.option1 || item.option1 == opts.option1) &&
        (!opts.option2 || item.option2 == opts.option2) &&
        (!opts.option3 || item.option3 == opts.option3);
    });
  }

  /** 更新价格显示 */
  function changePrice() {
    const curVariant = getCur();
    if (!curVariant) return;

    const num = parseInt($numDom.val()) || 1;

    // 识别当前页面使用的小数点符号
    const currentText = $priceDom.text().trim();
    const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);

    const decimalSeparator = decimalMatch ? decimalMatch[1] : '.';
    const decimalLength = decimalMatch ? decimalMatch[2].length : 0;

    // 格式化输出
    const formatValue = (cents) => {
      let val = (cents * num / 100).toFixed(decimalLength);
      if (decimalSeparator === ',') {
        val = val.replace('.', ',');
      }
      return val;
    };

    const price = formatValue(curVariant.price);
    const compare = formatValue(curVariant.compare_at_price);

    // 计算折扣
    let offPercent = 0;
    if (curVariant.compare_at_price > curVariant.price) {
      offPercent = 100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
    }

    const priceRegex = /\d+(?:[.,]\d+)*/;
    const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

    const updateHTML = ($el, regex, value) => {
      if ($el && $el.length) {
        const text = $el[0].textContent.trim();
        const newHtml = text.replace(regex, value);
        if ($el.html() !== newHtml) {
          $el.html(newHtml);
        }
      }
    };

    updateHTML($priceDom, priceRegex, price);
    updateHTML($cPriceDom, priceRegex, compare);
    updateHTML($offPriceDom, offRegex, offPercent);
  }

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  new WOW().init();

  jQuery(".sp-scroll").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  new Swiper('.mySwiper', {
    slidesPerView: 'auto',
    spaceBetween: 35,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    allowTouchMove: false,
  })

  new Swiper(".sp-swiper1", {
    speed: 2000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
  });

  new Swiper(".sp-swiper2", {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
  });

  function syncSpSwiper3Part5(swiper) {
    var $box = $(swiper.el).closest(".sp-ani.sp-ani-box");
    $box
      .find(".sp-img-box .sp-item")
      .removeClass("active")
      .eq(swiper.realIndex)
      .addClass("active");
    $box
      .find(".sp-text .sp-item")
      .removeClass("active")
      .eq(swiper.realIndex)
      .addClass("active");
  }

  $(".sp-part5 .sp-ani.sp-ani-box").each(function () {
    var $box = $(this);
    var el = $box.find(".sp-swiper3")[0];
    var pag = $box.find(".sp-pagination")[0];
    if (!el) return;
    var swiper = new Swiper(el, {
      autoplay: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      slideShadows: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: pag,
        clickable: true,
      },
      on: {
        init: function (s) {
          syncSpSwiper3Part5(s);
        },
        slideChange: function (s) {
          syncSpSwiper3Part5(s);
        },
      },
    });
    $box.find(".sp-text .sp-item").on("click", function () {
      var idx = $(this).index();
      swiper.slideToLoop(idx);
    });
  });

  new Swiper(".sp-swiper4", {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".sp-swiper-btn-next",
      prevEl: ".sp-swiper-btn-prev",
    },
  });

  new Swiper(".sp-swiper-fade", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });

  new Swiper(".sp-swiper-fade1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    on: {
      slideChange: function (e) {
        e.slides.find(".sp-text").each(function () {
          this.style.animation = "none";
        });
        const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
        if (spText) {
          spText.style.animation = "none";

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
        }
      },
    },
  });

  new Swiper(".sp-swiper0", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
              updateMainImage();
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            if (dataSrc) {
              image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            }
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
        config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    const moreCount = $("#sp-opt-group2 .sp-option").length;
    const bundleCount = $("#sp-opt-group3 .sp-option").length;

    let imgList = [];
    $(".product-part .sp-img-wrap .sp-pkg-panel img").each(function () {
      var s = $(this).attr("src");
      if (s && imgList.indexOf(s) === -1) {
        imgList.push(s);
      }
    });
    if (imgList.length) {
      preloadImages(imgList);
    }

    /* 套餐主图 .sp-img-wrap：设计稿移动 962×680、PC 731×516（与 index.css 一致），角标 left/top 按 SX/SY 缩放 */
    var PKG_WRAP_M = { w: 962, h: 680 };
    var PKG_WRAP_P = { w: 731, h: 516 };
    var PKG_SX = PKG_WRAP_P.w / PKG_WRAP_M.w;
    var PKG_SY = PKG_WRAP_P.h / PKG_WRAP_M.h;

    function setProductFreeBadgePos(leftM, topM) {
      var $el = $(".product-part .sp-img-wrap .sp-free");
      var mob = document.body && document.body.clientWidth <= 1060;
      if (mob) {
        $el.css({ left: leftM, top: topM });
      } else {
        $el.css({
          left: Math.round(leftM * PKG_SX),
          top: Math.round(topM * PKG_SY),
        });
      }
    }

    function getPkgCombinationIndex() {
      const colorNo = $("#sp-opt-group1 .sp-option.active").index();
      const moreNo = $("#sp-opt-group2 .sp-option.active").index();
    //   const bundleNo = $("#sp-opt-group3 .sp-option.active").index();
      return (
        colorNo + moreNo * 5
        // * (moreCount * bundleCount) +
        // moreNo * bundleCount +
        // bundleNo
      );
    }

    function syncProductFreeBadgeForSelection() {
      const moreNo = $("#sp-opt-group2 .sp-option.active").index();
      const bundleNo = $("#sp-opt-group3 .sp-option.active").index();
      var $free = $(".product-part .sp-img-wrap .sp-free");
      if (moreNo == 0) {
        $free.css("display", "none");
      } else {
        $free.css("display", "flex");
      }
      if (bundleNo == 0 && moreNo == 1) {
        setProductFreeBadgePos(755, 280);
      } else if (bundleNo == 0 && moreNo == 2) {
        setProductFreeBadgePos(765, 375);
      } else if (bundleNo == 1 && moreNo == 1) {
        setProductFreeBadgePos(605, 260);
      } else if (bundleNo == 1 && moreNo == 2) {
        setProductFreeBadgePos(715, 360);
      }
    }

    function updateMainPkgPanel() {
      syncProductFreeBadgeForSelection();
      var idx = getPkgCombinationIndex();
      var $panels = $(".product-part .sp-img-wrap .sp-pkg-panel");
      $panels.removeClass("active");
      var $show = $panels.filter('[data-pkg-index="' + idx + '"]');
      if ($show.length) {
        $show.addClass("active");
      } else {
        $panels.first().addClass("active");
      }
    }

    $(".sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      changePrice();
      updateMainPkgPanel();
    });

    updateMainPkgPanel();

    // IOS字体多了间距的处理
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);

    if (!isAndroid && !isIOS && !isPC) {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
  function handleShoppingLinkClick(event) {
    const link = event.target.closest('a[href="#shopping"]');
    if (!link) return;

    event.preventDefault();

    const targetElement = document.getElementById("shopping");
    if (targetElement) {
      const offsetTop = targetElement.offsetTop;
      let sptop = document.body.clientWidth <= 1080 ? 286 : 290;
      let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
      const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });

      setTimeout(() => {
        if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
          $('html, body').animate({
            scrollTop: scrollTop
          }, 800);
        }
      }, 100);
    }
  }

  // 使用事件委托在document上监听所有点击
  document.addEventListener('click', handleShoppingLinkClick);

  let sp_price1 = 9.99;
  let sp_price2 = 19.89;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }
  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice();
    // $("#sp_price1").html('$' + calcTotal(sp_price1, input.value));
    // $("#sp_price2").html('$' + calcTotal(sp_price2, input.value));
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice();
    // $("#sp_price1").html('$' + calcTotal(sp_price1, input.value));
    // $("#sp_price2").html('$' + calcTotal(sp_price2, input.value));
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span, div");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span/div 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    $(".sp-menu-mask").hide();
  });

  function getZoomValue() {
    let zoom = $("div#root").css("zoom");
    return parseFloat(zoom) || 1;
  }

  function handleScroll() {
    // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    // let zoomValue = getZoomValue();
    // let headerHeight = $(".header:visible").height() * zoomValue;

    // if (scrollTop > headerHeight) {
    //   $(".sp-pc .sp-header-top").addClass("sp-fixed");
    // } else {
    //   $(".sp-pc .sp-header-top").removeClass("sp-fixed");
    // }
  }

  // 初始检查
  handleScroll();

  // 监听多种滚动事件
  window.addEventListener('scroll', handleScroll, true);
  document.addEventListener('scroll', handleScroll, true);

  $(function () {
    // 判断是否为移动端
    function isMobile() {
      return document.body.clientWidth <= 1060;
    }

    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      if (isMobile()) {
        $(".sp-mobile .sp-cart .num").show();
        $(".sp-mobile .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-mobile .sp-cart").removeClass("on");
        }, 500);
      } else {
        $(".sp-pc .sp-header-top .sp-cart .num").show();
        $(".sp-pc .sp-header-top .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
        }, 500);
      }
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
    });

    let initNum = 0;

    $(".product-part .cart-btn").click(function () {
      let spNum = $("#calcNumber")[0].value;
    //   initNum += Number(spNum);

    var data = {
        id: getCur().id,
        quantity: spNum,
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            // $("#cardNum").html(result.item_count);
            console.log("result",result.item_count)
            initNum=result.item_count
            // 更新购物车数量
            if (isMobile()) {
              $(".sp-mobile .cardNum").each(function () {
                $(this).html(initNum);
              });
            } else {
              $(".sp-pc .cardNum").each(function () {
                $(this).html(initNum);
              });
            }
            $(".cardNum").removeClass("sp-gray");

          });
        },
        dataType: "json",
      });


      var $panel = $(".product-part .sp-img-wrap .sp-pkg-panel.active");
      if (!$panel.length) {
        return;
      }
      var el = $panel[0];
      var rect = el.getBoundingClientRect();
      if (rect.width < 2 || rect.height < 2) {
        return;
      }

      var flyer = el.cloneNode(true);
      flyer.classList.remove("active");
      flyer.classList.add("sp_pkg_flyer", "sp_clone");

      $(".product-part").append(flyer);
      $(flyer).css({
        position: "fixed",
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        margin: 0,
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        background: "#e7e9ef",
        zIndex: 99,
        pointerEvents: "none",
        overflow: "hidden",
      });

      let finish, targetTop, targetLeft;

      /* 落点与改版前一致：移动端为底部固定条 + 购物车区域；用 offsetTop/offsetLeft 与原先单图飞入一致 */
      if (isMobile()) {
        finish = $(".sp-btn-style2.sp-mobile .sp-cart");
        var barM = $(".sp-btn-style2.sp-mobile")[0];
        var cartM = finish[0];
        if (barM && cartM) {
          targetTop = barM.offsetTop;
          targetLeft = cartM.offsetLeft;
        } else {
          targetTop = 0;
          targetLeft = 0;
        }
      } else {
        finish = $(".sp-pc .sp-cart");
        if (finish.length > 0) {
          targetTop = finish[0].offsetTop;
          targetLeft = finish[0].offsetLeft;
        } else {
          targetTop = 0;
          targetLeft = 0;
        }
      }

      $(flyer).animate(
        {
          top: targetTop,
          left: targetLeft,
          width: 50,
          height: 50,
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
    });
  });

  // 问答
  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }

  // 公共 .sp-view-flash：勿放在 .sp-ani 内（父级 opacity:0 时子元素再闪也看不见）。用 filter+opacity+scale 原生闪烁；定时轮询补「无 scroll 时父级刚渐显」的情况。
  (function initSpViewFlash() {
    function spFlashChainOpacity(el) {
      var m = 1;
      var n = el;
      while (n && n !== document.documentElement) {
        var o = parseFloat(window.getComputedStyle(n).opacity);
        if (!isNaN(o)) m *= o;
        n = n.parentElement;
      }
      return m;
    }

    function playSpViewFlashOnce(el) {
      var delayMs = el.classList.contains("sp-view-flash-delay") ? 200 : 0;
      window.setTimeout(function () {
        el.style.transition =
          "opacity 0.2s ease, filter 0.2s ease, transform 0.2s ease";
        el.style.opacity = "0.22";
        el.style.filter = "brightness(2.5)";
        el.style.transform = "scale(1.16)";
        window.setTimeout(function () {
          el.style.opacity = "1";
          el.style.filter = "brightness(1)";
          el.style.transform = "scale(1)";
          window.setTimeout(function () {
            el.style.transition = "";
          }, 260);
        }, 230);
      }, delayMs);
    }

    function runSpViewFlashCheck() {
      var vh = window.innerHeight || 1;
      var vw = window.innerWidth || 1;
      document.querySelectorAll(".sp-view-flash").forEach(function (el) {
        if (el.getAttribute("data-sp-flash-done")) return;
        var cs = window.getComputedStyle(el);
        if (cs.display === "none" || cs.visibility === "hidden") return;
        var r = el.getBoundingClientRect();
        if (r.width < 2 || r.height < 2) return;
        var inView =
          r.top < vh && r.bottom > 0 && r.left < vw && r.right > 0;
        if (!inView) return;
        if (spFlashChainOpacity(el) < 0.12) return;
        el.setAttribute("data-sp-flash-done", "1");
        el.classList.add("sp-view-flash--play");
        playSpViewFlashOnce(el);
      });
    }

    function tickSpViewFlash() {
      requestAnimationFrame(runSpViewFlashCheck);
    }

    window.addEventListener("scroll", tickSpViewFlash, {
      passive: true,
      capture: true,
    });
    window.addEventListener("resize", tickSpViewFlash, { passive: true });
    document.addEventListener("scroll", tickSpViewFlash, {
      passive: true,
      capture: true,
    });

    document.querySelectorAll(".sp-view-flash").forEach(function (el) {
      if (el.tagName === "IMG") {
        el.addEventListener("load", tickSpViewFlash);
        if (el.complete) tickSpViewFlash();
      }
    });

    var pollN = 0;
    var pollId = window.setInterval(function () {
      runSpViewFlashCheck();
      pollN++;
      if (
        !document.querySelector(".sp-view-flash:not([data-sp-flash-done])") ||
        pollN > 75
      ) {
        window.clearInterval(pollId);
      }
    }, 200);

    tickSpViewFlash();
    window.setTimeout(tickSpViewFlash, 80);
  })();

  // sp-part6：悬挂绳拍立得无限滚动（时间步进 + 切线角平滑）
  (function initSpPart6StringCarousels() {
    var roots = document.querySelectorAll("[data-sp-string-carousel]");
    if (!roots.length) return;

    function isNarrow() {
      return document.body && document.body.clientWidth <= 1060;
    }

    function StringCarousel(root) {
      this.root = root;
      this.pathEl = root.querySelector(".sp-string-carousel__path");
      this.svgEl = root.querySelector(".sp-string-carousel__svg");
      this.trackEl = root.querySelector(".sp-string-carousel__track");
      this.cards = [];
      this.clipLift = 40;
      this.visible = true;
      this.resizeTimer = null;
      this.bind();
      this.layout();
      var self = this;
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              self.visible = e.isIntersecting;
            });
          },
          { root: null, threshold: 0, rootMargin: "80px" }
        );
        io.observe(root);
      }
    }

    StringCarousel.prototype.readParams = function () {
      var m = isNarrow();
      return {
        gap: m ? 44 : 48,
        /* PC：H 越大中间下垂越深（y=2t(1-t)H） */
        H: m ? 102 : 280,
        yOffset: m ? 45 : 35,
        speedPxSec: m ? 38 : 36,
        angleSmooth: m ? 16 : 14,
        angleDamp: m ? 0.72 : 0.82,
        hangGap: m ? 18 : 13,
      };
    };

    StringCarousel.prototype.layout = function () {
      var els = this.trackEl
        ? this.trackEl.querySelectorAll(".sp-string-carousel__card")
        : [];
      if (!els.length) return;
      var p = this.readParams();
      var w0 = els[0].offsetWidth || 200;
      this.cards = Array.prototype.map.call(els, function (el, i) {
        var w = el.offsetWidth || w0;
        return {
          el: el,
          x: i * (w + p.gap),
          width: w,
          smoothAngle: 0,
        };
      });
      var clipEl = els[0].querySelector(".sp-string-carousel__clip");
      if (clipEl) {
        var ct = parseFloat(window.getComputedStyle(clipEl).top);
        this.clipLift = !isNaN(ct) && ct !== 0 ? Math.abs(ct) : this.clipLift;
      }
    };

    StringCarousel.prototype.bind = function () {
      var self = this;
      window.addEventListener(
        "resize",
        function () {
          clearTimeout(self.resizeTimer);
          self.resizeTimer = setTimeout(function () {
            self.layout();
          }, 100);
        },
        { passive: true }
      );
      window.addEventListener("load", function () {
        self.layout();
      });
    };

    StringCarousel.prototype.step = function (dt) {
      if (!this.visible || !this.cards.length) return;
      var p = this.readParams();
      var W = this.root.offsetWidth || 1;
      var H = p.H;
      var y0 = p.yOffset;
      var gap = p.gap;
      var speed = p.speedPxSec * dt;
      var angK = 1 - Math.exp(-p.angleSmooth * dt);
      /* 绳与卡片同一抛物线 y=2t(1-t)H（t=x/W），纵坐标=卡片顶 ty - 夹子向上偏移，避免与二次贝塞尔参数化不一致 */
      var clipLift = this.clipLift || 40;
      /* 无 viewBox 时路径在 0、W 处描边被裁。用 viewBox 把 [-vbPad,W+vbPad]×[vbY,vbY+vbH] 等比映射到整块 SVG（与容器 W:elH 同比例，避免 none 拉变形） */
      var vbPad = 10;
      var elH = (this.root && this.root.offsetHeight) || 920;
      var vbW = W + 2 * vbPad;
      var vbH = (elH * vbW) / W;
      var vbY = 0;
      var svg = this.svgEl;
      if (svg) {
        svg.setAttribute("viewBox", -vbPad + " " + vbY + " " + vbW + " " + vbH);
      }
      var segs = Math.max(28, Math.min(100, Math.ceil((W + 2 * vbPad) / 10)));
      var pathParts = [];
      var si;
      for (si = 0; si <= segs; si++) {
        var sx = -vbPad + (si / segs) * (W + 2 * vbPad);
        var tu = sx / W;
        if (tu < 0) tu = 0;
        else if (tu > 1) tu = 1;
        var sy = 2 * tu * (1 - tu) * H + y0 + p.hangGap - clipLift;
        pathParts.push(
          (si === 0 ? "M " : " L ") +
            sx.toFixed(1) +
            " " +
            sy.toFixed(1)
        );
      }
      this.pathEl.setAttribute("d", pathParts.join(""));

      var cards = this.cards;
      var i;
      for (i = 0; i < cards.length; i++) {
        cards[i].x -= speed;
      }

      var guard = 0;
      while (guard++ < cards.length * 3) {
        var victim = null;
        for (i = 0; i < cards.length; i++) {
          var c = cards[i];
          if (c.x < -(c.width + gap)) {
            if (!victim || c.x < victim.x) victim = c;
          }
        }
        if (!victim) break;
        var maxRight = -Infinity;
        for (i = 0; i < cards.length; i++) {
          var rr = cards[i].x + cards[i].width;
          if (rr > maxRight) maxRight = rr;
        }
        victim.x = maxRight + gap;
      }

      for (i = 0; i < cards.length; i++) {
        var card = cards[i];
        var centerX = card.x + card.width * 0.5;
        var t = centerX / W;
        if (t < 0) t = 0;
        else if (t > 1) t = 1;
        var y = 2 * t * (1 - t) * H;
        var dyDx = (2 * H * (1 - 2 * t)) / W;
        var targetAngle =
          ((Math.atan(dyDx) * 180) / Math.PI) * p.angleDamp;
        card.smoothAngle += (targetAngle - card.smoothAngle) * angK;
        var tx = centerX - card.width * 0.5;
        var ty = y + y0 + p.hangGap;
        card.el.style.transform =
          "translate3d(" +
          tx +
          "px," +
          ty +
          "px,0) rotate(" +
          card.smoothAngle +
          "deg)";
      }
    };

    var instances = [];
    for (var r = 0; r < roots.length; r++) {
      instances.push(new StringCarousel(roots[r]));
    }

    var lastT = performance.now();
    function frame(now) {
      var dt = Math.min((now - lastT) / 1000, 0.048);
      lastT = now;
      for (var j = 0; j < instances.length; j++) {
        instances[j].step(dt);
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  })();
});
